import { Link, useNavigate, useParams } from "react-router-dom";
import { TbSquareRoundedPlus } from "react-icons/tb";
import { AiOutlinePlusSquare, AiOutlineUnorderedList } from "react-icons/ai";
import { LuSearch } from "react-icons/lu";
import { useState } from "react";
import Pagination from "../../utils/views/pagination";
import { useQuery } from "react-query";
import { getCategories, getProducts } from "../../api/product";
import CategoryModal from "../modals/CategoryModal";

export default function Products() {
  const { data } = useQuery("categories", getCategories);
  const [open, setOpen] = useState(false);
  const [categoryData, setCategoryData] = useState(null);

  return (
    <div className="w-full p-4">
      <div className="flex justify-between items-center">
        <div className="font-bold text-[#070E05] text-[22px]">Products</div>
        <Link
          to={"/products/create"}
          className="font-bold text-[#2121F1] text-[15px] bg-[#2121F11A] p-2 rounded-md inline-flex items-center gap-2 leading-[20.83px] cursor-pointer"
        >
          <TbSquareRoundedPlus className="text-[17px]" />
          <span>Add Product</span>
        </Link>
      </div>
      <ProductManager />

      {/* Categories */}
      <div className="flex flex-col gap-4 my-5">
        <div className="flex justify-between items-center font-dmsans">
          <div className="font-medium text-[17px]">Categories</div>

          <div className="flex gap-4">
            <div
              className="bg-[#2121F11A] p-2 rounded-[5px] cursor-pointer"
              title="Add category"
              onClick={() => setOpen(true)}
            >
              <div className="text-[#2121F1] font-bold text-[15px] font-Neurial flex items-center gap-1">
                <AiOutlinePlusSquare />
                <span>Add Category</span>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          {(data || []).map((category, k) => {
            return (
              <div
                onClick={() => {
                  setCategoryData(category);
                  setOpen(true);
                }}
                key={k}
                className="inline-block bg-white cursor-pointer p-3 space-y-3 m-2 rounded-lg w-[90px] h-[94px]"
              >
                <div className="w-[40px] h-[40px] rounded-lg border-[#D9D9D9] border-[1px] mx-auto">
                  <img
                    className="w-full h-[40px]"
                    src={category?.image ? category?.image[0] : ""}
                    alt={data.title}
                  />
                </div>
                <div className="text-[13px] font-Neurial text-center">
                  {category.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <CategoryModal open={open} setOpen={setOpen} data={categoryData} />
    </div>
  );
}

export function noToLocale(number) {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  return Number(number).toLocaleString("en", options);
}

export function ProductOptionHandler(props) {
  let param = useParams();
  return <ProductManager {...props} params={param} />;
}

const boxShadowStyle = {
  boxShadow: "0px 2px 9px 0px #00000008",
  userSelect: "none",
};

export const ProductManager = () => {
  const [gridView, setgridView] = useState(false);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const { data: productData } = useQuery(["products", search], () =>
    getProducts(search)
  );

  return (
    <div className="flex flex-col gap-4 mt-5 font-dmsans">
      <div className="flex items-center justify-between">
        <div className="text-[18px] font-medium">All Products</div>
        <div className="">
          <div className="flex items-center gap-[10px]">
            <div
              className="border-[1px] border-[#E9EFF4] bg-white rounded-lg py-2 px-2 cursor-pointer"
              title={`Switch to ${gridView ? "List View" : "Grid View"}`}
              style={boxShadowStyle}
              onClick={() => setgridView((prev) => !prev)}
            >
              <div className="text-[14px] text-[#A0A3BD] leading-5 flex items-center gap-2 w-full h-full">
                <AiOutlineUnorderedList />
                <span>{gridView ? "List View" : "Grid View"}</span>
              </div>
            </div>
            {/* <div
              className="border-[1px] border-[#E9EFF4] bg-white rounded-lg py-2 px-2 cursor-pointer"
              title={`Filter`}
              style={boxShadowStyle}
            >
              <div className="text-[14px] text-[#A0A3BD] leading-5 flex items-center gap-10 w-full h-full">
                <span>Filter</span>
                <BsSliders />
              </div>
            </div> */}
            <div
              className="border-[1px] border-[#E9EFF4] bg-white rounded-lg py-2 px-2 cursor-pointer"
              title={`Search`}
              style={boxShadowStyle}
            >
              <div className="text-[14px] text-[#A0A3BD] leading-5 flex items-center gap-2 w-full h-full relative">
                <LuSearch className="text-[18px]" />
                <input
                  className="w-[120px] placeholder:text-[#A0A3BD] text-[13px] outline-none text-black bg-transparent"
                  placeholder=" Type to Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="">
        {gridView ? (
          <div className="grid grid-cols-3 gap-5">
            {(productData || []).map((v, k) => {
              return <GridItem key={k} data={v || {}} />;
            })}
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {(productData || []).map((v, k) => {
              return <ListItem key={k} data={v || {}} />;
            })}
          </div>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <div className="text-[14px]"></div>
        </div>

        <Pagination currentPage={1} totalPages={20} showPageCount={false} />
      </div>
    </div>
  );
};

function GridItem(props) {
  const navigate = useNavigate();
  const { data } = props;

  return (
    <div
      className="rounded-lg bg-white w-full font-dmsans font-normal cursor-pointer"
      onClick={() => {
        navigate(`/products/${data?._id}`);
      }}
    >
      <div className="h-[130px] w-full border-[1px] border-[#dbdbdb73] rounded-t-lg">
        <img
          className="w-full h-[130px]"
          src={data?.imageUrls[0]}
          alt={data.title}
        />
      </div>
      <div className="flex flex-col gap-3  p-3">
        <div className="text-[12px] capitalize">{data?.title}</div>
        <div className="flex justify-between items-center text-[12px] text-[#828282]">
          <div className="">{data?.category}</div>
          <div className="">{data?.variants?.length} Variants</div>
        </div>
      </div>
    </div>
  );
}

function ListItem(props) {
  const { data } = props;
  const navigate = useNavigate();

  return (
    <div
      className="rounded-lg w-full bg-white font-dmsans font-normal justify-between flex items-center p-3 cursor-pointer"
      onClick={() => {
        navigate(`/products/${data?._id}`);
      }}
    >
      <div className=" w-1/5">
        <div className="h-[64px] w-[64px] border-[1px] border-[#dbdbdb73] rounded-lg ">
          <img
            className="w-full h-[64px]"
            src={data?.imageUrls[0]}
            alt={data.title}
          />
        </div>
      </div>
      <div className=" w-1/5">
        <div className="text-[12px] capitalize">{data?.title}</div>
      </div>
      <div className=" w-1/5">
        <div className=" text-[12px] text-[#828282]">{data?.category}</div>
      </div>
      <div className=" w-1/5">
        <div className=" text-[12px] text-[#828282]">
          {data?.variants?.length} Variants
        </div>
      </div>
      {/* <div className=" w-1/5">
        <div className="flex text-[#F9A414] text-[15px]">
          <BsFillStarFill />
          <BsFillStarFill />
          <BsFillStarFill />
          <BsFillStarFill />
          <BsFillStarFill className="text-[#F9A4144D]" />
        </div>
      </div> */}
      {/* <div className=" w-1/5">
        <div className="text-[12px] text-[#828282] text-center">Rating</div>
      </div> */}
    </div>
  );
}

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}
